export const TOWN_PREFERENCES_KEY = 'pixel-town:preferences';

export const DEFAULT_TOWN_PREFERENCES = Object.freeze({
  viewMode: 'pixel',
  townSize: 'large',
  movementSpeed: 'standard',
  ambience: true,
  rememberPosition: true,
  showNameTags: true,
});

const TOWN_SIZES = new Set(['small', 'medium', 'large']);
const MOVEMENT_SPEEDS = new Set(['relaxed', 'standard', 'fast']);

export function normalizeTownPreferences(value) {
  const source = value && typeof value === 'object' ? value : {};
  return {
    // Migrate earlier 3D preferences without resetting size, movement or position settings.
    viewMode: 'pixel',
    townSize: TOWN_SIZES.has(source.townSize)
      ? source.townSize
      : DEFAULT_TOWN_PREFERENCES.townSize,
    movementSpeed: MOVEMENT_SPEEDS.has(source.movementSpeed)
      ? source.movementSpeed
      : DEFAULT_TOWN_PREFERENCES.movementSpeed,
    ambience: typeof source.ambience === 'boolean'
      ? source.ambience
      : DEFAULT_TOWN_PREFERENCES.ambience,
    rememberPosition: typeof source.rememberPosition === 'boolean'
      ? source.rememberPosition
      : DEFAULT_TOWN_PREFERENCES.rememberPosition,
    showNameTags: typeof source.showNameTags === 'boolean'
      ? source.showNameTags
      : DEFAULT_TOWN_PREFERENCES.showNameTags,
  };
}

export function loadTownPreferences() {
  try {
    return normalizeTownPreferences(JSON.parse(localStorage.getItem(TOWN_PREFERENCES_KEY) || 'null'));
  } catch {
    return { ...DEFAULT_TOWN_PREFERENCES };
  }
}

export function saveTownPreferences(value) {
  const normalized = normalizeTownPreferences(value);
  try {
    localStorage.setItem(TOWN_PREFERENCES_KEY, JSON.stringify(normalized));
  } catch {
    // The town remains usable when browser storage is unavailable.
  }
  return normalized;
}
